<template>
    <div
        :class="appearance === 'black' ? 'fin-bg-stone-900 fin-p-5 fin-text-white fin-flex-1' : 'fin-bg-white fin-p-5 fin-text-black fin-flex-1'">
        <div class="fin-flex fin-items-center fin-justify-between fin-mb-3" v-if="!header_hidden">
            <div class="fin-flex fin-flex-col fin-space-y-4">
                <img :src="logo" width="100" height="100"/>
            </div>

            <div class="fin-flex fin-justify-between fin-items-center">
                <el-badge
                    :value="notificationCount"
                    :max="99"
                    :hidden="notificationCount === 0"
                    class="item mr-4"
                >
                    <i class="el-icon-message el-button el-button--default el-button--small is-circle"></i>
                </el-badge>
            </div>
        </div>

        <el-carousel :interval="minutes" height="100vh">
            <el-carousel-item v-for="(item, index) in dashboards"
                              :key="index"
                              :index="index">
                <component
                    v-show="_.get(item, 'dashboardView') === 'charts'"
                    :is="'dashboard-charts'"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard="item"
                    v-bind:dashboard-id="_.get(item, 'dashboardId')"
                    v-bind:selected-views="JSON.parse(_.get(item, 'selectedWidgets'))"
                    v-bind:computed-widgets="computedWidgets"
                    class="fin-w-full fin-w-full"
                />

                <component
                    v-show="_.get(item, 'dashboardView') === 'settlements'"
                    :is="'settlements-chart'"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard="item"
                    v-bind:dashboard-id="_.get(item, 'dashboardId')"
                    v-bind:selected-widgets="JSON.parse(_.get(item, 'selectedWidgets'))"
                    v-bind:computed-widgets="computedWidgets"
                    class="fin-w-full fin-w-full"
                />

                <component
                    v-show="_.get(item, 'dashboardView') === 'broker-breakdowns'"
                    :is="'broker-breakdowns'"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard="item"
                    v-bind:dashboard-id="_.get(item, 'dashboardId')"
                    v-bind:selected-widgets="JSON.parse(_.get(item, 'selectedWidgets'))"
                    v-bind:computed-widgets="computedWidgets"
                    class="fin-w-full fin-w-full"
                />

                <component
                    v-show="_.get(item, 'dashboardView') === 'totals'"
                    :is="'dashboard-totals'"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard="item"
                    v-bind:dashboard-id="_.get(item, 'dashboardId')"
                    v-bind:selected-widgets="JSON.parse(_.get(item, 'selectedWidgets'))"
                    v-bind:computed-widgets="computedWidgets"
                    v-bind:cards="cards"
                    class="fin-w-full fin-w-full"
                />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import DashboardCharts from "./DashboardCharts";
import SubmissionsChart from "../SubmissionsChart";
import SettledChart from "../SetteledChart";
import LeadSettlementChart from "../LeadSettlementChart";
import BrokerSettledChart from "../BrokerSettledChart";
import BrokerNafChart from "../BrokerNafChart";
import BrokerIncomeChart from "../BrokerIncomeChart";
import LenderIncomeChart from "../LenderIncomeChart";
import LenderSettledChart from "../LenderSettledChart";
import LenderNafChart from "../LenderNafChart";
import TeamNafChart from "../TeamNafChart";
import TeamIncomeChart from "../TeamIncomeChart";
import TeamSettledChart from "../TeamSettledChart";
import ActivityChart from "../ActivityChart";
import AverageIncomeChart from "../AverageIncomeChart";
import TotalIncomeChart from "../TotalIncomeChart";
import ClosedApplicationChart from "../ClosedApplicationChart";
import draggable from "vuedraggable";
import VueGridLayout from 'vue-grid-layout'
import AverageIncomeCard from "../card-totals/AverageIncomeCard";
import SettledCard from "../card-totals/SetteledCard";
import BrokerIncomeCard from "../card-totals/BrokerIncomeCard";
import BrokerNafCard from "../card-totals/BrokerNafCard";
import BrokerSettledCard from "../card-totals/BrokerSettledCard";
import closedApplicationCard from "../card-totals/ClosedApplicationCard";
import LenderIncomeCard from "../card-totals/LenderIncomeCard";
import LenderNafCard from "../card-totals/LenderNafCard";
import LenderSettledCard from "../card-totals/LenderSettledCard";
import SubmissionsCard from "../card-totals/SubmissionsCard";
import TeamIncomeCard from "../card-totals/TeamIncomeCard";
import TeamNafCard from "../card-totals/TeamNafCard";
import TeamSettledCard from "../card-totals/TeamSettledCard";
import TotalIncomeCard from "../card-totals/TotalIncomeCard";
import dashboardCarousel from "../slider/DashboardCarousel";
import SettlementsChart from "../SettlementsChart";
import cards from "../card-totals/cards.json";
import DashboardTotals from "./DashboardTotals";
import BrokerBreakdowns from "../BrokerBreakdowns";

export default {
    name: 'DisplayMultipleDashboards',
    props: [
        'tenantId',
        'mergedDashboard',
        'logo'
    ],
    components: {
        "dashboard-charts": DashboardCharts,
        "submissions-chart": SubmissionsChart,
        "settled-chart": SettledChart,
        "lead-settlement-chart": LeadSettlementChart,
        "broker-settled-chart": BrokerSettledChart,
        "broker-naf-chart": BrokerNafChart,
        "broker-income-chart": BrokerIncomeChart,
        "lender-income-chart": LenderIncomeChart,
        "lender-settled-chart": LenderSettledChart,
        "lender-naf-chart": LenderNafChart,
        "team-settled-chart": TeamSettledChart,
        "team-income-chart": TeamIncomeChart,
        "team-naf-chart": TeamNafChart,
        "activity-chart": ActivityChart,
        "average-income-chart": AverageIncomeChart,
        "total-income-chart": TotalIncomeChart,
        "closed-application-chart": ClosedApplicationChart,
        "average-income-card": AverageIncomeCard,
        "settled-card": SettledCard,
        "broker-income-card": BrokerIncomeCard,
        "broker-naf-card": BrokerNafCard,
        "broker-settled-card": BrokerSettledCard,
        "closed-application-card": closedApplicationCard,
        "lender-income-card": LenderIncomeCard,
        "lender-naf-card": LenderNafCard,
        "lender-settled-card": LenderSettledCard,
        "submissions-card": SubmissionsCard,
        "team-income-card": TeamIncomeCard,
        "team-naf-card": TeamNafCard,
        "team-settled-card": TeamSettledCard,
        "total-income-card": TotalIncomeCard,
        draggable,
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        "dashboard-carousel": dashboardCarousel,
        "settlements-chart": SettlementsChart,
        "dashboard-totals": DashboardTotals,
        "broker-breakdowns": BrokerBreakdowns,
    },
    data() {
        return {
            appearance: '',
            minutes: 10000,
            dashboards: [],
            uniqueDashboards: [],
            cards: cards,
            header_hidden: false,
            notificationCount: 0,
            widgets: [
                {
                    x: 0,
                    y: 2,
                    w: 4,
                    h: 7,
                    width: "350",
                    height: "350",
                    id: "submissions-chart",
                    order: 0,
                    i: "0",
                    ref: "Submissions",
                    title: "Submissions",
                    permission: {},
                    component: "submissions-chart",
                    props: {}
                },
                {
                    x: 2,
                    y: 2,
                    w: 4,
                    h: 3.5,
                    width: "350",
                    height: "350",
                    id: "settled-chart",
                    order: 1,
                    i: "1",
                    ref: "settled",
                    title: "Settled",
                    permission: {},
                    component: "settled-chart",
                    props: {}
                },
                {
                    x: 4,
                    y: 2,
                    w: 4,
                    h: 8.5,
                    width: "350",
                    height: "350",
                    id: "lead-settlement-chart",
                    order: 2,
                    i: "2",
                    ref: "lead-to-settlement",
                    title: "Lead To Settlement",
                    permission: {},
                    component: "lead-settlement-chart",
                    props: {}
                },
                {
                    x: 6,
                    y: 2,
                    w: 4,
                    h: 6.5,
                    width: "350",
                    height: "350",
                    id: "broker-settled-chart",
                    order: 3,
                    i: "3",
                    ref: "broker-settled-chart",
                    title: "Broker Settled Leaderboards",
                    permission: {},
                    component: "broker-settled-chart",
                    props: {}
                },
                {
                    x: 8,
                    y: 2,
                    w: 4,
                    h: 6.5,
                    width: "350",
                    height: "350",
                    id: "broker-naf-chart",
                    order: 4,
                    i: "4",
                    ref: "broker-naf-chart",
                    title: "Broker Naf Leaderboards",
                    permission: {},
                    component: "broker-naf-chart",
                    props: {}
                },
                {
                    x: 10,
                    y: 2,
                    w: 4,
                    h: 6.5,
                    width: "350",
                    height: "350",
                    id: "broker-income-chart",
                    order: 5,
                    i: "5",
                    ref: "broker-income-chart",
                    title: "Broker Income Leaderboards",
                    permission: {},
                    component: "broker-income-chart",
                    props: {}
                },
                {
                    x: 0,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "lender-naf-chart",
                    order: 6,
                    i: "6",
                    ref: "lender-naf-chart",
                    title: "Lender Naf Leaderboard",
                    permission: {},
                    component: "lender-naf-chart",
                    props: {}
                },
                {
                    x: 2,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "lender-settled-chart",
                    order: 7,
                    i: "7",
                    ref: "lender-settled-chart",
                    title: "Lender Settled Leaderboard",
                    permission: {},
                    component: "lender-settled-chart",
                    props: {}
                },
                {
                    x: 4,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "lender-income-chart",
                    order: 8,
                    i: "8",
                    ref: "lender-income-chart",
                    title: "Lender Income Leaderboard",
                    permission: {},
                    component: "lender-income-chart",
                    props: {}
                },
                {
                    x: 6,
                    y: 2,
                    w: 4,
                    h: 4.5,
                    width: "350",
                    height: "350",
                    id: "team-naf-chart",
                    order: 9,
                    i: "9",
                    ref: "team-naf-chart",
                    title: "Team Naf Leaderboard",
                    permission: {},
                    component: "team-naf-chart",
                    props: {}
                },
                {
                    x: 8,
                    y: 2,
                    w: 4,
                    h: 4.5,
                    width: "350",
                    height: "350",
                    id: "team-income-chart",
                    order: 10,
                    i: "10",
                    ref: "team-income-chart",
                    title: "Team Income Leaderboard",
                    permission: {},
                    component: "team-income-chart",
                    props: {}
                },
                {
                    x: 10,
                    y: 2,
                    w: 4,
                    h: 4.5,
                    width: "350",
                    height: "350",
                    id: "team-settled-chart",
                    order: 11,
                    i: "11",
                    ref: "team-settled-chart",
                    title: "Team Settled Leaderboard",
                    permission: {},
                    component: "team-settled-chart",
                    props: {}
                },
                {
                    x: 0,
                    y: 2,
                    w: 4,
                    h: 8.5,
                    width: "350",
                    height: "350",
                    id: "activity-chart",
                    order: 12,
                    i: "12",
                    ref: "activity-chart",
                    title: "Activity",
                    permission: {},
                    component: "activity-chart",
                    props: {}
                },
                {
                    x: 2,
                    y: 2,
                    w: 4,
                    h: 7.5,
                    width: "350",
                    height: "350",
                    id: "total-income-chart",
                    order: 13,
                    i: "13",
                    ref: "total-income-chart",
                    title: "Total income",
                    permission: {},
                    component: "total-income-chart",
                    props: {}
                },
                {
                    x: 4,
                    y: 2,
                    w: 4,
                    h: 6,
                    width: "350",
                    height: "350",
                    id: "average-income-chart",
                    order: 14,
                    i: "14",
                    ref: "average-income-chart",
                    title: "Average income",
                    permission: {},
                    component: "average-income-chart",
                    props: {}
                },
                {
                    x: 6,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "closed-application-chart",
                    order: 15,
                    i: "15",
                    ref: "closed-application-chart",
                    title: "Closed Applications",
                    permission: {},
                    component: "closed-application-chart",
                    props: {}
                },
                {
                    x: 8,
                    y: 2,
                    w: 4,
                    h: 10,
                    width: "350",
                    height: "350",
                    id: "settlements",
                    order: 16,
                    i: "16",
                    ref: "settlements",
                    title: "Settlements",
                    permission: {},
                    component: "settlements",
                    props: {}
                }
            ]
        }
    },
    computed: {
        computedWidgets() {
            return this.widgets
        }
    },
    watch: {},
    mounted() {
        this.appearance = _.get(this.mergedDashboard, 'appearance')
        this.minutes = Number(_.get(this.mergedDashboard, 'minutes')) * 60000

        this.dashboardPollWidgetsData()

        Echo.private(`merged-dashboards.${this.tenantId}.${window.DashboardID}`).listen(".merged-dashboard-live", (event) => {
            this.appearance = _.get(event, 'mergedDashboard.appearance', _.get(this.mergedDashboard, 'appearance'))
            this.minutes = Number(_.get(event, 'mergedDashboard.minutes', _.get(this.mergedDashboard, 'minutes'))) * 60000
            this.notificationCount = event.emailNotifications
            this.header_hidden = _.get(event, 'mergedDashboard.header_hidden', _.get(this.mergedDashboard, 'header_hidden')) === 1
        })

        const dashboards = _.get(this.mergedDashboard, 'dashboards', [])
        dashboards.map((dashboard) => {
            Echo.private(`dashboard.${this.tenantId}.${dashboard}`).listen(".dashboard-live", (event) => {
                if (this.dashboards.indexOf(event) === -1) {
                    this.dashboards.push(event);
                    const ids = [...new Set(this.dashboards.map(x => x.dashboardId))];

                    this.dashboards = ids.map(id => this.dashboards.find(x => x.dashboardId === id));
                }
            })
        })
    },
    created() {
        Echo.private(`merged-dashboards.${this.tenantId}.${window.DashboardID}`).listen(".merged-dashboard-live", (event) => {
            this.appearance = _.get(event, 'mergedDashboard.appearance', _.get(this.mergedDashboard, 'appearance'))
            this.minutes = Number(_.get(event, 'mergedDashboard.minutes', _.get(this.mergedDashboard, 'minutes'))) * 60000
            this.notificationCount = event.emailNotifications
            this.header_hidden = _.get(event, 'mergedDashboard.header_hidden', _.get(this.mergedDashboard, 'header_hidden')) === 1
        })

        const dashboards = _.get(this.mergedDashboard, 'dashboards', [])
        dashboards.map((dashboard) => {
            Echo.private(`dashboard.${this.tenantId}.${dashboard}`).listen(".dashboard-live", (event) => {
                if (this.dashboards.indexOf(event) === -1) {
                    this.dashboards.push(event);
                    const ids = [...new Set(this.dashboards.map(x => x.dashboardId))];

                    this.dashboards = ids.map(id => this.dashboards.find(x => x.dashboardId === id));
                }
            })
        })
    },
    destroyed() {
        Echo.leave(`merged-dashboards.${this.tenantId}.${window.DashboardID}`)

        const dashboards = _.get(this.mergedDashboard, 'dashboards', [])
        dashboards.map((dashboard) => {
            Echo.leave(`dashboard.${this.tenantId}.${dashboard}`)
        })
    },
    methods: {
        dashboardPollWidgetsData() {
            setInterval(function () {
                this.poll()
            }.bind(this), 60000)
        },
        poll() {
            axios.get("/admin/settings/dashboard/" + window.DashboardID + "/poll-merged-dashboards").then()
        }
    }
}
</script>

<style lang="scss" scoped>
.carousel-3d-container {
}

.carousel-3d-slide {
    border-color: rgba(0, 0, 0, 0.5);
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
}

.el-carousel {
    border: none;
    height: 100vh;
}

.el-carousel__item {
    border: none;
}
</style>
